var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg208396(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "475.46pt",
    height: "166pt",
    viewBox: "0 0 475.46 166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 447 85 L 475.460938 85 L 475.460938 122 L 447 122 Z M 447 85 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.198914%,77.999878%,54.499817%)",
      fillOpacity: 1
    },
    d: "M 99.363281 44.8125 C 102.4375 44.039063 105.65625 43.621094 108.976563 43.621094 C 113.03125 43.621094 116.941406 44.238281 120.621094 45.378906 C 118.222656 37.628906 113.496094 30.910156 107.261719 26.023438 C 98.539063 26.285156 90.3125 28.496094 83 32.246094 C 89.195313 35.425781 94.738281 39.691406 99.363281 44.8125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(91.799927%,55.699158%,34.098816%)",
      fillOpacity: 1
    },
    d: "M 57.816406 108.183594 C 60.15625 112.929688 63.128906 117.300781 66.636719 121.183594 C 72.054688 119.828125 77.019531 117.339844 81.28125 113.996094 C 72.875 113.746094 64.925781 111.691406 57.816406 108.183594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.198914%,77.999878%,54.499817%)",
      fillOpacity: 1
    },
    d: "M 99.363281 121.183594 C 94.738281 126.308594 89.195313 130.578125 83 133.753906 C 90.3125 137.503906 98.539063 139.71875 107.261719 139.976563 C 113.496094 135.089844 118.222656 128.371094 120.621094 120.621094 C 116.941406 121.761719 113.03125 122.378906 108.976563 122.378906 C 105.65625 122.378906 102.4375 121.964844 99.363281 121.183594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(91.799927%,55.699158%,34.098816%)",
      fillOpacity: 1
    },
    d: "M 66.636719 44.8125 C 63.128906 48.695313 60.15625 53.074219 57.808594 57.816406 C 64.925781 54.308594 72.875 52.25 81.28125 52 C 77.019531 48.65625 72.054688 46.167969 66.636719 44.8125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,87.5%,74.099731%)",
      fillOpacity: 1
    },
    d: "M 165.992188 83 C 165.992188 60.550781 153.019531 41.136719 134.160156 31.84375 C 137.90625 39.433594 140.019531 47.976563 140.019531 57.023438 C 140.019531 57.597656 139.992188 58.164063 139.976563 58.734375 C 145.21875 65.425781 148.351563 73.84375 148.351563 83 C 148.351563 92.15625 145.21875 100.578125 139.976563 107.265625 C 139.992188 107.832031 140.019531 108.398438 140.019531 108.980469 C 140.019531 118.019531 137.90625 126.566406 134.160156 134.160156 C 153.019531 124.863281 165.992188 105.449219 165.992188 83 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(91.799927%,55.299377%,34.098816%)",
      fillOpacity: 1
    },
    d: "M 71.351563 71.355469 C 64.328125 73.527344 58.152344 77.613281 53.417969 83 C 58.152344 88.386719 64.328125 92.472656 71.355469 94.648438 C 70.214844 90.964844 69.605469 87.054688 69.605469 83 C 69.605469 78.945313 70.214844 75.035156 71.351563 71.355469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.898987%,65.499878%,32.199097%)",
      fillOpacity: 1
    },
    d: "M 94.644531 71.355469 C 95.78125 75.035156 96.394531 78.945313 96.394531 83 C 96.394531 87.054688 95.78125 90.964844 94.640625 94.648438 C 101.664063 92.472656 107.839844 88.386719 112.574219 83 C 107.839844 77.613281 101.664063 73.527344 94.644531 71.355469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.198914%,77.999878%,54.499817%)",
      fillOpacity: 1
    },
    d: "M 66.636719 44.8125 C 71.257813 39.691406 76.800781 35.425781 83 32.246094 C 75.683594 28.496094 67.457031 26.28125 58.734375 26.023438 C 52.503906 30.910156 47.773438 37.628906 45.371094 45.378906 C 49.054688 44.238281 52.964844 43.621094 57.019531 43.621094 C 60.339844 43.621094 63.554688 44.039063 66.636719 44.8125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.898987%,65.499878%,32.199097%)",
      fillOpacity: 1
    },
    d: "M 108.183594 57.820313 C 105.839844 53.074219 102.867188 48.699219 99.363281 44.8125 C 93.941406 46.167969 88.976563 48.65625 84.714844 52 C 93.117188 52.25 101.070313 54.308594 108.183594 57.820313 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.198914%,77.999878%,54.499817%)",
      fillOpacity: 1
    },
    d: "M 66.636719 121.183594 C 63.554688 121.964844 60.339844 122.378906 57.019531 122.378906 C 52.964844 122.378906 49.054688 121.761719 45.371094 120.621094 C 47.773438 128.371094 52.503906 135.089844 58.734375 139.976563 C 67.457031 139.71875 75.683594 137.503906 83 133.753906 C 76.800781 130.578125 71.257813 126.308594 66.636719 121.183594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.898987%,65.499878%,32.199097%)",
      fillOpacity: 1
    },
    d: "M 99.363281 121.183594 C 102.867188 117.300781 105.839844 112.929688 108.183594 108.179688 C 101.070313 111.691406 93.117188 113.746094 84.714844 113.996094 C 88.976563 117.339844 93.941406 119.828125 99.363281 121.183594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,87.5%,74.099731%)",
      fillOpacity: 1
    },
    d: "M 26.019531 107.265625 C 20.777344 100.574219 17.644531 92.15625 17.644531 83 C 17.644531 73.84375 20.777344 65.425781 26.019531 58.734375 C 26 58.160156 25.976563 57.597656 25.976563 57.023438 C 25.976563 47.976563 28.089844 39.433594 31.835938 31.839844 C 12.980469 41.136719 0 60.550781 0 83 C 0 105.449219 12.980469 124.859375 31.835938 134.160156 C 28.089844 126.566406 25.976563 118.019531 25.976563 108.980469 C 25.976563 108.398438 26 107.832031 26.019531 107.265625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.898987%,65.499878%,32.199097%)",
      fillOpacity: 1
    },
    d: "M 108.183594 108.179688 C 112.925781 105.84375 117.296875 102.867188 121.1875 99.359375 C 119.828125 93.945313 117.339844 88.976563 113.996094 84.714844 C 113.746094 93.121094 111.6875 101.074219 108.183594 108.179688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(97.599792%,86.299133%,77.2995%)",
      fillOpacity: 1
    },
    d: "M 58.734375 26.023438 C 65.425781 20.777344 73.839844 17.644531 83 17.644531 C 92.15625 17.644531 100.574219 20.777344 107.261719 26.023438 C 107.832031 26.003906 108.40625 25.976563 108.976563 25.976563 C 118.015625 25.976563 126.5625 28.09375 134.160156 31.839844 C 124.855469 12.980469 105.449219 -0.00390625 83 -0.00390625 C 60.550781 -0.00390625 41.136719 12.980469 31.835938 31.839844 C 39.433594 28.09375 47.980469 25.976563 57.019531 25.976563 C 57.59375 25.976563 58.167969 26.003906 58.734375 26.023438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.898987%,65.499878%,32.199097%)",
      fillOpacity: 1
    },
    d: "M 71.355469 94.648438 C 73.527344 101.664063 77.609375 107.84375 83 112.574219 C 88.386719 107.84375 92.46875 101.664063 94.640625 94.648438 C 90.960938 95.785156 87.050781 96.398438 83 96.398438 C 78.945313 96.398438 75.027344 95.785156 71.355469 94.648438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.498779%,57.299805%,33.699036%)",
      fillOpacity: 1
    },
    d: "M 44.808594 99.359375 C 48.699219 102.867188 53.070313 105.84375 57.816406 108.183594 C 54.308594 101.070313 52.246094 93.121094 52 84.714844 C 48.65625 88.976563 46.171875 93.945313 44.808594 99.359375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(97.299194%,83.099365%,68.199158%)",
      fillOpacity: 1
    },
    d: "M 120.621094 45.378906 C 121.757813 49.058594 122.371094 52.96875 122.371094 57.023438 C 122.371094 60.339844 121.957031 63.558594 121.1875 66.640625 C 126.308594 71.257813 130.574219 76.804688 133.753906 83 C 137.503906 75.683594 139.714844 67.457031 139.976563 58.734375 C 135.089844 52.5 128.367188 47.773438 120.621094 45.378906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.198914%,77.999878%,54.499817%)",
      fillOpacity: 1
    },
    d: "M 44.808594 66.640625 C 44.039063 63.558594 43.625 60.335938 43.625 57.023438 C 43.625 52.96875 44.234375 49.058594 45.371094 45.378906 C 37.628906 47.773438 30.90625 52.5 26.019531 58.734375 C 26.277344 67.457031 28.492188 75.683594 32.242188 83 C 35.421875 76.804688 39.6875 71.261719 44.808594 66.640625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.498779%,43.499756%,18.798828%)",
      fillOpacity: 1
    },
    d: "M 83 112.574219 C 77.609375 107.84375 73.527344 101.664063 71.355469 94.648438 C 64.328125 92.472656 58.152344 88.386719 53.417969 83 C 52.929688 83.558594 52.457031 84.132813 52 84.710938 C 52.246094 93.121094 54.308594 101.070313 57.816406 108.183594 C 64.929688 111.691406 72.875 113.75 81.28125 114 C 81.867188 113.542969 82.441406 113.066406 83 112.574219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.099854%,74.899292%,50.999451%)",
      fillOpacity: 1
    },
    d: "M 107.261719 26.023438 C 113.496094 30.910156 118.222656 37.628906 120.621094 45.378906 C 128.367188 47.773438 135.089844 52.5 139.976563 58.734375 C 139.992188 58.164063 140.019531 57.597656 140.019531 57.023438 C 140.019531 47.976563 137.90625 39.433594 134.160156 31.839844 C 126.5625 28.09375 118.015625 25.976563 108.976563 25.976563 C 108.40625 25.976563 107.832031 26.003906 107.261719 26.023438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.499207%,58.799744%,20.799255%)",
      fillOpacity: 1
    },
    d: "M 112.574219 83 C 107.839844 88.386719 101.664063 92.472656 94.640625 94.648438 C 92.46875 101.664063 88.386719 107.84375 83 112.574219 C 83.550781 113.066406 84.128906 113.542969 84.714844 114 C 93.117188 113.75 101.070313 111.691406 108.183594 108.179688 C 111.6875 101.074219 113.746094 93.121094 113.996094 84.714844 C 113.535156 84.132813 113.0625 83.558594 112.574219 83 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.399353%,69.398499%,41.999817%)",
      fillOpacity: 1
    },
    d: "M 26.019531 58.734375 C 30.90625 52.5 37.628906 47.773438 45.371094 45.378906 C 47.773438 37.628906 52.503906 30.910156 58.734375 26.023438 C 58.167969 26.007813 57.59375 25.976563 57.019531 25.976563 C 47.980469 25.976563 39.433594 28.09375 31.835938 31.839844 C 28.089844 39.433594 25.976563 47.976563 25.976563 57.023438 C 25.976563 57.597656 26 58.164063 26.019531 58.734375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.299866%,51.799011%,18.798828%)",
      fillOpacity: 1
    },
    d: "M 84.714844 114 C 84.128906 113.542969 83.550781 113.066406 83 112.574219 C 82.441406 113.066406 81.867188 113.542969 81.28125 114 C 77.019531 117.339844 72.054688 119.828125 66.636719 121.183594 C 71.257813 126.308594 76.800781 130.578125 83 133.753906 C 89.195313 130.578125 94.738281 126.308594 99.363281 121.183594 C 93.941406 119.828125 88.976563 117.339844 84.714844 114 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.898987%,65.499878%,32.199097%)",
      fillOpacity: 1
    },
    d: "M 94.644531 71.355469 C 92.472656 64.328125 88.386719 58.15625 83 53.421875 C 77.609375 58.15625 73.527344 64.328125 71.351563 71.355469 C 75.027344 70.214844 78.945313 69.601563 83 69.601563 C 87.054688 69.601563 90.960938 70.214844 94.644531 71.355469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(97.299194%,83.099365%,68.199158%)",
      fillOpacity: 1
    },
    d: "M 121.1875 99.359375 C 121.957031 102.441406 122.375 105.660156 122.375 108.980469 C 122.375 113.03125 121.757813 116.941406 120.621094 120.621094 C 128.367188 118.226563 135.089844 113.496094 139.976563 107.265625 C 139.714844 98.539063 137.503906 90.3125 133.753906 83 C 130.574219 89.195313 126.308594 94.738281 121.1875 99.359375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.198914%,77.999878%,54.499817%)",
      fillOpacity: 1
    },
    d: "M 44.808594 99.359375 C 39.6875 94.738281 35.421875 89.195313 32.242188 83 C 28.492188 90.3125 26.277344 98.539063 26.019531 107.265625 C 30.90625 113.496094 37.628906 118.222656 45.371094 120.621094 C 44.234375 116.941406 43.625 113.03125 43.625 108.980469 C 43.625 105.660156 44.039063 102.441406 44.808594 99.359375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.898987%,65.499878%,32.199097%)",
      fillOpacity: 1
    },
    d: "M 113.996094 81.285156 C 117.339844 77.019531 119.828125 72.054688 121.1875 66.640625 C 117.296875 63.128906 112.925781 60.15625 108.183594 57.816406 C 111.6875 64.929688 113.746094 72.875 113.996094 81.285156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(97.599792%,86.299133%,77.2995%)",
      fillOpacity: 1
    },
    d: "M 107.261719 139.976563 C 100.574219 145.21875 92.15625 148.351563 83 148.351563 C 73.839844 148.351563 65.425781 145.21875 58.734375 139.976563 C 58.167969 139.992188 57.59375 140.019531 57.019531 140.019531 C 47.976563 140.019531 39.429688 137.90625 31.835938 134.160156 C 41.136719 153.019531 60.550781 166 83 166 C 105.449219 166 124.855469 153.019531 134.160156 134.160156 C 126.5625 137.90625 118.015625 140.023438 108.976563 140.023438 C 108.40625 140.023438 107.832031 139.996094 107.261719 139.976563 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.498779%,57.598877%,33.699036%)",
      fillOpacity: 1
    },
    d: "M 57.8125 57.820313 C 53.070313 60.15625 48.699219 63.128906 44.808594 66.640625 C 46.171875 72.054688 48.65625 77.019531 52 81.285156 C 52.246094 72.878906 54.308594 64.929688 57.8125 57.820313 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.498779%,43.499756%,18.798828%)",
      fillOpacity: 1
    },
    d: "M 53.417969 83 C 58.152344 77.613281 64.328125 73.523438 71.351563 71.355469 C 73.527344 64.332031 77.609375 58.160156 83 53.425781 C 82.441406 52.933594 81.867188 52.460938 81.28125 52 C 72.875 52.25 64.925781 54.308594 57.8125 57.820313 C 54.308594 64.929688 52.246094 72.878906 52 81.285156 C 52.457031 81.871094 52.929688 82.441406 53.417969 83 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.099854%,74.899292%,50.999451%)",
      fillOpacity: 1
    },
    d: "M 139.976563 107.265625 C 135.089844 113.496094 128.367188 118.226563 120.621094 120.621094 C 118.222656 128.371094 113.496094 135.089844 107.261719 139.976563 C 107.832031 139.996094 108.40625 140.023438 108.976563 140.023438 C 118.015625 140.023438 126.5625 137.90625 134.160156 134.160156 C 137.90625 126.566406 140.019531 118.019531 140.019531 108.980469 C 140.019531 108.398438 139.992188 107.832031 139.976563 107.265625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.399353%,69.398499%,41.999817%)",
      fillOpacity: 1
    },
    d: "M 58.734375 139.976563 C 52.503906 135.089844 47.773438 128.371094 45.371094 120.621094 C 37.628906 118.222656 30.90625 113.496094 26.019531 107.265625 C 26 107.832031 25.976563 108.398438 25.976563 108.980469 C 25.976563 118.019531 28.089844 126.566406 31.835938 134.160156 C 39.429688 137.90625 47.980469 140.019531 57.019531 140.019531 C 57.59375 140.019531 58.167969 139.992188 58.734375 139.976563 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.499207%,58.799744%,20.799255%)",
      fillOpacity: 1
    },
    d: "M 83 53.425781 C 88.386719 58.160156 92.472656 64.332031 94.644531 71.355469 C 101.664063 73.527344 107.839844 77.613281 112.574219 83 C 113.0625 82.441406 113.535156 81.871094 113.996094 81.285156 C 113.75 72.875 111.6875 64.929688 108.183594 57.820313 C 101.070313 54.308594 93.117188 52.25 84.714844 52 C 84.125 52.460938 83.554688 52.933594 83 53.425781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.299866%,51.799011%,18.798828%)",
      fillOpacity: 1
    },
    d: "M 83 32.246094 C 76.804688 35.425781 71.257813 39.691406 66.636719 44.8125 C 72.054688 46.167969 77.019531 48.65625 81.28125 52 C 81.867188 52.460938 82.441406 52.933594 83 53.425781 C 83.554688 52.933594 84.125 52.460938 84.714844 52 C 88.976563 48.65625 93.941406 46.167969 99.363281 44.8125 C 94.738281 39.691406 89.195313 35.425781 83 32.246094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.498779%,43.499756%,18.798828%)",
      fillOpacity: 1
    },
    d: "M 52 81.285156 C 48.65625 77.019531 46.171875 72.054688 44.808594 66.640625 C 39.6875 71.261719 35.421875 76.804688 32.242188 83 C 35.421875 89.195313 39.6875 94.738281 44.808594 99.359375 C 46.171875 93.945313 48.65625 88.976563 52 84.710938 C 52.457031 84.132813 52.929688 83.558594 53.417969 83 C 52.929688 82.441406 52.457031 81.871094 52 81.285156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.499207%,58.799744%,20.799255%)",
      fillOpacity: 1
    },
    d: "M 121.1875 66.640625 C 119.828125 72.054688 117.339844 77.019531 113.996094 81.285156 C 113.535156 81.871094 113.0625 82.441406 112.574219 83 C 113.0625 83.558594 113.535156 84.132813 113.996094 84.714844 C 117.339844 88.976563 119.828125 93.945313 121.1875 99.359375 C 126.308594 94.738281 130.574219 89.195313 133.753906 83 C 130.574219 76.804688 126.308594 71.261719 121.1875 66.640625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(57.998657%,55.299377%,50.59967%)",
      fillOpacity: 1
    },
    d: "M 269.429688 121.972656 L 269.429688 102.316406 C 269.429688 100.066406 268.078125 98.414063 264.929688 98.414063 C 263.277344 98.414063 262.078125 98.863281 261.027344 99.765625 L 261.027344 121.972656 L 252.023438 121.972656 L 252.023438 102.167969 C 252.023438 99.917969 250.222656 98.414063 247.074219 98.414063 C 245.421875 98.414063 244.519531 98.5625 243.46875 99.011719 L 243.46875 121.972656 L 234.46875 121.972656 L 234.46875 95.414063 C 237.914063 94.0625 241.671875 93.308594 247.074219 93.308594 C 252.175781 93.308594 255.175781 94.664063 256.976563 96.164063 C 258.925781 94.664063 262.078125 93.308594 267.179688 93.308594 C 274.683594 93.308594 278.4375 97.363281 278.4375 102.316406 L 278.4375 121.972656 L 269.429688 121.972656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(57.998657%,55.299377%,50.59967%)",
      fillOpacity: 1
    },
    d: "M 299.882813 117.46875 C 299.128906 117.773438 297.933594 117.921875 296.582031 117.921875 C 292.980469 117.921875 291.027344 116.574219 291.027344 113.269531 C 291.027344 108.769531 294.480469 107.71875 299.882813 107.117188 Z M 296.132813 93.308594 C 290.578125 93.308594 286.527344 94.664063 284.425781 95.414063 L 286.375 100.066406 C 288.328125 99.3125 291.476563 98.414063 294.480469 98.414063 C 297.78125 98.414063 299.882813 99.167969 299.882813 102.167969 L 299.882813 103.515625 C 290.578125 104.269531 282.476563 106.367188 282.476563 113.570313 C 282.476563 119.421875 287.128906 122.421875 296.132813 122.421875 C 301.535156 122.421875 305.734375 121.671875 308.285156 120.324219 L 308.285156 103.664063 C 308.285156 96.011719 303.183594 93.308594 296.132813 93.308594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(57.998657%,55.299377%,50.59967%)",
      fillOpacity: 1
    },
    d: "M 400.882813 117.46875 C 399.980469 117.773438 398.933594 117.921875 397.578125 117.921875 C 393.980469 117.921875 391.878906 116.574219 391.878906 113.269531 C 391.878906 108.769531 395.480469 107.71875 400.882813 107.117188 Z M 396.980469 93.308594 C 391.578125 93.308594 387.527344 94.664063 385.273438 95.414063 L 387.226563 100.066406 C 389.328125 99.3125 392.328125 98.414063 395.328125 98.414063 C 398.632813 98.414063 400.882813 99.167969 400.882813 102.167969 L 400.882813 103.515625 C 391.425781 104.269531 383.476563 106.367188 383.476563 113.570313 C 383.476563 119.421875 388.128906 122.421875 397.132813 122.421875 C 402.535156 122.421875 406.734375 121.671875 409.285156 120.324219 L 409.285156 103.664063 C 409.285156 96.011719 404.035156 93.308594 396.980469 93.308594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(57.998657%,55.299377%,50.59967%)",
      fillOpacity: 1
    },
    d: "M 331.542969 121.972656 L 331.542969 102.316406 C 331.542969 100.363281 330.496094 98.414063 326.894531 98.414063 C 325.09375 98.414063 324.039063 98.714844 322.992188 99.011719 L 322.992188 121.972656 L 313.988281 121.972656 L 313.988281 95.414063 C 317.140625 94.214844 321.640625 93.308594 327.042969 93.308594 C 336.945313 93.308594 340.550781 97.210938 340.550781 102.316406 L 340.550781 121.972656 L 331.542969 121.972656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(57.998657%,55.299377%,50.59967%)",
      fillOpacity: 1
    },
    d: "M 432.394531 121.972656 L 432.394531 102.316406 C 432.394531 100.363281 431.34375 98.414063 427.742188 98.414063 C 425.941406 98.414063 425.039063 98.714844 423.992188 99.011719 L 423.992188 121.972656 L 414.988281 121.972656 L 414.988281 95.414063 C 417.984375 94.214844 422.492188 93.308594 428.039063 93.308594 C 437.945313 93.308594 441.398438 97.210938 441.398438 102.316406 L 441.398438 121.972656 L 432.394531 121.972656 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(57.998657%,55.299377%,50.59967%)",
      fillOpacity: 1
    },
    d: "M 465.253906 121.972656 L 456.402344 107.71875 L 456.253906 107.71875 L 456.253906 121.972656 L 447.246094 121.972656 L 447.246094 87.3125 C 447.246094 87.3125 450.101563 85.0625 456.253906 85.0625 L 456.253906 106.21875 L 456.402344 106.21875 L 465.105469 93.914063 L 474.113281 93.914063 L 464.359375 106.519531 L 475.460938 121.972656 L 465.253906 121.972656 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(57.998657%,55.299377%,50.59967%)",
      fillOpacity: 1
    },
    d: "M 228.914063 125.273438 L 228.914063 95.414063 L 219.761719 95.414063 L 219.761719 126.324219 C 219.761719 130.675781 219.160156 133.078125 217.207031 134.582031 C 216.761719 134.878906 216.460938 135.027344 216.007813 135.328125 L 217.960938 139.683594 C 219.160156 139.53125 220.363281 139.082031 221.5625 138.480469 C 223.8125 137.277344 225.761719 135.328125 227.113281 132.929688 C 228.164063 130.828125 228.914063 128.277344 228.914063 125.273438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(57.998657%,55.299377%,50.59967%)",
      fillOpacity: 1
    },
    d: "M 228.914063 84.457031 L 224.265625 84.457031 C 221.714844 84.457031 219.761719 86.261719 219.761719 88.210938 L 219.761719 91.660156 L 228.914063 91.660156 L 228.914063 84.457031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(57.998657%,55.299377%,50.59967%)",
      fillOpacity: 1
    },
    d: "M 200.066406 97.789063 C 199.320313 95.28125 199.144531 93.460938 199.144531 93.460938 L 199.027344 93.460938 C 199.027344 93.460938 198.796875 95.238281 197.988281 97.789063 L 194.28125 109.464844 L 203.601563 109.464844 Z M 207.308594 121.972656 L 204.878906 114.308594 L 192.890625 114.308594 L 190.34375 121.972656 L 181.949219 121.972656 L 193.941406 89.792969 C 193.941406 89.792969 196.621094 86.113281 204.070313 86.113281 L 216.984375 121.972656 L 207.308594 121.972656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 372.933594 39.371094 L 369.605469 39.371094 C 366.996094 39.371094 364.972656 41.078125 364.972656 43.066406 L 364.972656 45.996094 L 372.933594 45.996094 L 372.933594 39.371094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 372.015625 68.746094 C 370.992188 70.078125 369.6875 70.511719 368.578125 70.511719 C 366.625 70.511719 365.398438 69.199219 364.679688 67.5 C 363.953125 65.800781 363.714844 63.699219 363.714844 62.054688 C 363.714844 60.476563 364.074219 58.796875 364.902344 57.496094 C 365.726563 56.195313 367.027344 55.285156 368.867188 55.285156 C 370.636719 55.285156 371.871094 56.121094 372.652344 57.335938 C 373.429688 58.546875 373.765625 60.121094 373.769531 61.628906 C 373.765625 65.195313 373.03125 67.410156 372.015625 68.746094 M 382.054688 63.402344 C 382.054688 55.722656 376.84375 49.894531 369.027344 49.894531 C 361.207031 49.894531 354.839844 55.722656 354.839844 63.546875 C 354.839844 66.242188 355.273438 68.519531 356.285156 70.371094 L 355.414063 70.371094 C 335.007813 70.371094 342.605469 51.601563 342.605469 51.601563 L 336.960938 49.183594 C 333.472656 54.769531 331.015625 64.933594 337.824219 72.074219 C 341.882813 76.34375 348.179688 77.476563 354.839844 77.476563 L 367.144531 77.476563 C 375.394531 77.476563 382.054688 71.789063 382.054688 63.402344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 465.914063 70.507813 L 465.914063 70.597656 L 463.511719 70.597656 C 460.808594 70.597656 459.066406 69.464844 458.023438 67.6875 C 456.980469 65.914063 456.621094 63.507813 456.621094 60.941406 C 456.621094 59.363281 457.019531 57.820313 457.828125 56.664063 C 458.636719 55.507813 459.863281 54.742188 461.484375 54.742188 C 463.175781 54.738281 464.300781 55.511719 464.980469 56.6875 C 465.664063 57.863281 465.914063 59.4375 465.914063 61.082031 Z M 430.847656 70.511719 L 410.4375 70.511719 C 412.753906 65.246094 419.703125 57.003906 426.652344 57.003906 C 428.242188 57.003906 429.257813 57.429688 429.835938 58.425781 C 430.414063 59.5625 430.847656 61.414063 430.847656 63.828125 Z M 473.632813 58.425781 C 473.050781 56.578125 472.328125 55.152344 471.316406 53.875 C 470.300781 52.597656 468.996094 51.601563 467.40625 50.890625 C 465.957031 50.175781 464.222656 49.894531 462.195313 49.894531 C 460.167969 49.894531 458.140625 50.175781 456.550781 50.746094 C 454.808594 51.3125 453.21875 52.308594 451.917969 53.589844 C 450.757813 54.730469 449.742188 56.289063 449.019531 58.140625 C 448.441406 59.988281 448.152344 62.261719 448.152344 64.824219 C 448.152344 65.390625 448.007813 66.101563 447.863281 66.8125 C 447.71875 67.523438 447.429688 68.234375 447.140625 68.800781 C 446.703125 69.230469 446.414063 69.65625 445.980469 69.941406 C 445.402344 70.371094 444.96875 70.511719 444.386719 70.511719 L 439.679688 70.511719 L 439.679688 63.117188 C 439.679688 58.851563 438.667969 55.441406 436.496094 53.304688 C 434.324219 51.03125 431.429688 49.894531 427.808594 49.894531 C 425.925781 49.894531 424.191406 50.320313 422.453125 51.03125 C 420.859375 51.742188 419.269531 52.597656 417.820313 53.734375 C 416.371094 54.871094 415.070313 56.148438 413.914063 57.570313 C 413.621094 57.996094 413.476563 58.425781 413.1875 58.710938 L 413.1875 50.746094 C 407.398438 50.746094 405.078125 52.738281 404.644531 53.019531 L 404.644531 70.511719 L 399.800781 70.511719 C 397.917969 70.511719 396.617188 68.519531 396.324219 66.8125 C 396.179688 66.101563 396.035156 65.390625 396.035156 64.824219 L 396.035156 50.746094 C 390.242188 50.746094 387.929688 52.738281 387.496094 53.019531 L 387.496094 73.085938 C 387.496094 75.785156 387.058594 78.15625 386.046875 79.152344 C 385.648438 79.542969 385.148438 79.835938 382 80.058594 L 382 86.28125 C 391.847656 86.144531 396.464844 81.761719 396.035156 73.921875 C 396.960938 76.65625 402.824219 77.476563 405.515625 77.476563 L 442.21875 77.476563 C 446.558594 77.476563 448.878906 74.917969 450.179688 71.929688 C 453.363281 76.765625 457.996094 77.476563 462.628906 77.476563 L 474.355469 77.476563 L 474.355469 64.113281 C 474.355469 61.980469 474.066406 60.132813 473.632813 58.425781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 203.445313 39.191406 L 199.996094 39.191406 C 197.296875 39.191406 195.195313 40.960938 195.195313 43.023438 L 195.195313 46.097656 L 203.445313 46.097656 L 203.445313 39.191406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 272.015625 84.695313 L 272.015625 87.765625 L 280.261719 87.765625 L 280.261719 80.863281 L 276.8125 80.863281 C 274.113281 80.863281 272.015625 82.632813 272.015625 84.695313 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 215.425781 66.207031 L 215.425781 48.058594 C 209.425781 48.058594 207.027344 50.121094 206.574219 50.414063 L 206.574219 66.058594 C 206.574219 71.433594 205.589844 72.386719 201.226563 72.539063 C 200.203125 72.578125 199 72.539063 197.578125 72.539063 C 192.730469 71.71875 190.910156 67.058594 190.6875 61.789063 L 190.6875 49.109375 C 184.691406 49.109375 182.289063 51.171875 181.988281 51.464844 L 181.988281 59.285156 C 181.539063 68.894531 184.832031 78.582031 197.125 78.582031 L 200.578125 78.582031 C 209.121094 78.582031 215.871094 75.484375 215.425781 66.207031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 255.066406 70.257813 L 252.664063 70.257813 C 247.117188 70.257813 245.617188 65.648438 245.617188 60.347656 C 245.617188 57.105469 247.269531 54.011719 250.566406 54.011719 C 254.015625 54.011719 255.066406 57.105469 255.066406 60.492188 Z M 317.433594 70.257813 C 312.335938 70.257813 307.386719 68.34375 307.386719 62.746094 C 307.386719 55.824219 314.433594 53.320313 319.988281 55.527344 L 321.332031 50.078125 L 320.734375 49.933594 C 311.4375 46.984375 298.839844 51.109375 298.839844 62.304688 C 298.839844 64.957031 299.738281 68.050781 301.535156 70.257813 L 295.710938 70.257813 C 293.761719 70.257813 292.410156 68.195313 292.113281 66.425781 C 291.960938 65.691406 291.808594 64.957031 291.808594 64.367188 C 291.808594 62.449219 291.511719 60.535156 290.914063 58.769531 C 290.3125 56.855469 289.261719 55.382813 287.761719 54.054688 C 286.261719 52.730469 284.3125 51.554688 281.914063 50.816406 C 278.3125 49.636719 270.363281 49.492188 266.613281 50.371094 L 268.5625 55.527344 C 273.960938 55.234375 279.8125 54.203125 282.363281 60.09375 C 282.664063 61.273438 282.8125 64.070313 282.8125 65.691406 L 282.8125 70.257813 L 263.765625 70.257813 L 263.765625 63.628906 C 263.765625 55.824219 259.867188 48.898438 251.320313 48.898438 C 245.019531 48.898438 239.917969 51.554688 237.671875 57.441406 C 236.917969 59.359375 236.621094 61.714844 236.621094 64.367188 C 236.621094 66.574219 235.570313 70.257813 232.71875 70.257813 L 229.351563 70.257813 L 229.351563 36.234375 C 223.351563 36.234375 220.804688 38.445313 220.804688 38.445313 L 220.652344 38.59375 L 220.652344 77.476563 L 232.269531 77.476563 C 236.019531 77.179688 238.421875 76.300781 240.070313 73.207031 C 242.617188 76.59375 247.414063 77.476563 251.765625 77.476563 L 282.664063 77.476563 C 282.664063 77.476563 291.0625 77.476563 291.808594 73.792969 C 293.011719 76.738281 295.261719 77.621094 297.960938 77.476563 L 323.019531 77.476563 L 323.019531 70.257813 L 317.433594 70.257813 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(57.998657%,55.299377%,50.59967%)",
      fillOpacity: 1
    },
    d: "M 362.695313 105.367188 L 360.847656 105.367188 L 360.847656 116.847656 C 361.769531 117.15625 362.867188 117.363281 364.425781 117.363281 C 368.753906 117.363281 371.289063 115.808594 371.289063 111.707031 C 371.289063 107.453125 369.09375 105.367188 362.695313 105.367188 M 363.925781 90.359375 C 362.539063 90.359375 361.886719 90.46875 360.847656 90.78125 L 360.847656 101.324219 L 362.695313 101.324219 C 367.878906 101.324219 370.214844 99.605469 370.214844 95.710938 C 370.214844 92.078125 368.199219 90.359375 363.925781 90.359375 M 364.652344 122.402344 C 359.175781 122.402344 354.90625 121.671875 351.964844 120.324219 L 351.964844 87.71875 C 354.617188 86.472656 358.007813 85.636719 363.203125 85.636719 C 373.644531 85.636719 378.488281 89.789063 378.488281 95.140625 C 378.488281 99.8125 375.558594 102.304688 372.390625 103.03125 L 372.390625 103.140625 C 375.964844 103.96875 380.632813 107.085938 380.632813 112.023438 C 380.632813 119.132813 374.519531 122.402344 364.652344 122.402344 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg208396);
export default __webpack_public_path__ + "static/media/208396.4d2e107c0ce53c0cd843fcf11dbb7b46.svg";
export { ForwardRef as ReactComponent };